(function () {
  'use strict';

  var DAGEN = ['maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'];
  var MAX_UREN_KLOK = 24;

  function winkelTijd(tijdzone) {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: tijdzone }));
    } catch (e) {
      return new Date();
    }
  }

  function isoDag(date) {
    var d = date.getDay();
    return d === 0 ? 7 : d;
  }

  function padTwee(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function klok(ms) {
    var totaal = Math.max(0, Math.floor(ms / 1000));
    var u = Math.floor(totaal / 3600);
    var m = Math.floor((totaal % 3600) / 60);
    var s = totaal % 60;
    return padTwee(u) + ':' + padTwee(m) + ':' + padTwee(s);
  }

  function volgendeCutoff(nu, verzenddagen, uur, minuut) {
    for (var i = 0; i <= 8; i++) {
      var kandidaat = new Date(nu.getTime());
      kandidaat.setDate(kandidaat.getDate() + i);
      kandidaat.setHours(uur, minuut, 0, 0);
      if (kandidaat > nu && verzenddagen.indexOf(isoDag(kandidaat)) !== -1) {
        return { moment: kandidaat, offset: i, dag: DAGEN[isoDag(kandidaat) - 1] };
      }
    }
    return null;
  }

  function vulSjabloon(sjabloon, waarden) {
    return sjabloon.replace(/\{(\w+)\}/g, function (heel, sleutel) {
      return Object.prototype.hasOwnProperty.call(waarden, sleutel) ? waarden[sleutel] : heel;
    });
  }

  function tekenCountdown() {
    var el = document.querySelector('[data-vv-countdown]');
    if (!el) return;

    var doel = el.querySelector('[data-vv-countdown-msg]');
    if (!doel) return;

    var tijdzone = el.dataset.timezone || 'Europe/Amsterdam';
    var uur = parseInt(el.dataset.cutoffHour, 10);
    var minuut = parseInt(el.dataset.cutoffMinute, 10) || 0;
    var verzenddagen = (el.dataset.shippingDays || '1,2,3,4,5')
      .split(',')
      .map(function (d) {
        return parseInt(d.trim(), 10);
      })
      .filter(function (d) {
        return d >= 1 && d <= 7;
      });

    if (isNaN(uur) || verzenddagen.length === 0) {
      el.hidden = true;
      return;
    }

    var nu = winkelTijd(tijdzone);
    var volgende = volgendeCutoff(nu, verzenddagen, uur, minuut);

    if (!volgende) {
      el.hidden = true;
      return;
    }

    var resterend = volgende.moment - nu;
    var vandaag = volgende.offset === 0;
    var dagLabel = volgende.offset === 1 ? 'morgen' : volgende.dag;

    if (vandaag) {
      doel.innerHTML = vulSjabloon(el.dataset.tplOpen || 'Bestel binnen {clock}', {
        clock: '<strong>' + klok(resterend) + '</strong>'
      });
    } else if (resterend <= MAX_UREN_KLOK * 3600 * 1000) {
      doel.innerHTML = vulSjabloon(el.dataset.tplNext || 'Bestel binnen {clock} = {day} verzonden!', {
        clock: '<strong>' + klok(resterend) + '</strong>',
        day: dagLabel
      });
    } else {
      doel.innerHTML = vulSjabloon(el.dataset.tplClosed || 'Wij verzenden {day}.', {
        day: '<strong>' + dagLabel + '</strong>'
      });
    }

    el.hidden = false;
  }

  tekenCountdown();
  setInterval(tekenCountdown, 1000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tekenCountdown();
  });

  function cartRoute(naam, fallback) {
    return (window.routes && window.routes[naam]) || fallback;
  }

  function drawerElement() {
    return document.querySelector('cart-drawer');
  }

  function ververs(parsed) {
    var drawer = drawerElement();

    if (drawer && typeof drawer.renderContents === 'function' && parsed && parsed.sections) {
      drawer.renderContents(parsed);
      return Promise.resolve();
    }

    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var nieuw = new DOMParser().parseFromString(html, 'text/html');
        var bronInner = nieuw.querySelector('#CartDrawer .drawer__inner');
        var huidigInner = document.querySelector('#CartDrawer .drawer__inner');
        if (bronInner && huidigInner) {
          huidigInner.innerHTML = bronInner.innerHTML;
        }
        var bronDrawer = nieuw.querySelector('cart-drawer');
        if (bronDrawer && drawer) {
          drawer.classList.toggle('is-empty', bronDrawer.classList.contains('is-empty'));
        }
        if (drawer && typeof drawer.open === 'function') drawer.open();
        tekenCountdown();
      });
  }

  document.addEventListener('click', function (event) {
    var knop = event.target.closest ? event.target.closest('[data-vv-upsell-add]') : null;
    if (!knop) return;

    event.preventDefault();
    if (knop.getAttribute('aria-busy') === 'true') return;

    var variantId = knop.dataset.variantId;
    if (!variantId) return;

    knop.setAttribute('aria-busy', 'true');

    var drawer = drawerElement();
    var body = {
      items: [{ id: Number(variantId), quantity: 1 }]
    };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) {
        return s.section;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(cartRoute('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (parsed) {
        if (parsed.status) {
          var foutvak = document.getElementById('CartDrawer-CartErrors');
          if (foutvak) foutvak.textContent = parsed.description || parsed.message || '';
          return;
        }
        return ververs(parsed);
      })
      .catch(function () {
        window.location.href = cartRoute('cart_url', '/cart');
      })
      .finally(function () {
        knop.removeAttribute('aria-busy');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
  });
})();